<template>
    <div class="query">
        <!--        <div class="title">-->
        <!--            <p class="return" @click="back">-->
        <!--                <img src="~@public/img/user/login/jian.png"/>-->
        <!--            </p>-->
        <!--            开锁业从业单位 人名名录查询-->
        <!--        </div>-->
        <van-radio-group v-model="radio" class="van-radio" @change="changeList">
            <p>选择类型:</p>
            <van-radio name="1" class="van-name">单位</van-radio>
            <van-radio name="2" class="van-name">个人</van-radio>
        </van-radio-group>
        <van-field required readonly clickable :value="city" label="所属市州:" placeholder="请选择"
                   @click="showPickerCity = true"/>
        <van-popup v-model="showPickerCity" position="bottom">
            <van-picker show-toolbar :columns="cityList" @cancel="showPickerCity = false"
                        value-key="regionname" @confirm="onConfirmCity"/>
        </van-popup>
        <van-field required readonly clickable :value="county" label="所属区县:" placeholder="请选择"
                   @click="showPickerCounty = true"/>
        <van-popup v-model="showPickerCounty" position="bottom">
            <van-picker show-toolbar :columns="countyList" @cancel="showPickerCounty = false"
                        value-key="regionname" @confirm="onConfirmCounty"/>
        </van-popup>
        <van-cell-group>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <!--        单位查询页面-->
<!--        <div v-if="enterprise">-->
<!--            <div class="boxList-item">-->
<!--                <span>企业名称:</span>-->
<!--                <span>UI中心</span>-->
<!--            </div>-->
<!--            <div class="boxList-item">-->
<!--                <span>登记地址:</span>-->
<!--                <span>江苏省苏州市</span>-->
<!--            </div>-->
<!--            <div class="boxList-item">-->
<!--                <span>统一社会信息代码:</span>-->
<!--                <span>1232313</span>-->
<!--            </div>-->
<!--            <div class="boxList-item">-->
<!--                <span>所属地区:</span>-->
<!--                <span>苏州</span>-->
<!--            </div>-->
<!--        </div>-->
        <van-list v-if="personal" class="list" v-model="loading" :finished="finished" finished-text="没有更多了"
                  :error.sync="error"
                  error-text="请求失败，点击重新加载"
                  @click="loadMore">
            <div></div>
            <div class="boxList" v-for="(item,index) in list" :key="index" style="border-bottom: 2px solid #868686;">
                <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">个人开锁业信息</van-divider>
                <div class="boxList-item">
                    <span>姓名:</span>
                    <span>{{item.lockerName}}</span>
                </div>
                <div class="boxList-item">
                    <span>性别:</span>
                    <span>{{item.sex=1?'男':'女'}}</span>
                </div>
                <div class="boxList-item">
                    <span>联系方式:</span>
                    <span>{{item.lockerPhone}}</span>
                </div>
                <div class="boxList-item">
                    <span>地址:</span>
                    <span>{{item.lockerAddr}}</span>
                </div>
            </div>
        </van-list>

    </div>
</template>

<script>
    import {CellGroup, Field, Toast, Button, RadioGroup, Radio,Popup,Picker,Dialog,List,Divider} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import { queryApiMap} from "../../api/query";
    import {baseApiMap} from "../../api/base";
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "UnlockQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Dialog.name]: Dialog,
            [List.name]:List,
            [Divider .name]: Divider
        },
        data() {
            return {
                show: false,
                radio: '2',
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                enterprise: false,//单位查询状态得显示与隐藏
                personal: false,//个人查询状态得显示与隐藏
                city: '',  //市州
                cityList: [],//市州集合
                showPickerCity: false, //是否显示市州选择框
                county: '',  //区县
                countyList: [],    //区县集合
                showPickerCounty: false,   //是否显示区县选择框
                cityCode:'',
                countyCode:'',
                list:[],
                ps: 2,
                loading: false, // 是否显示加载loading图标
                finished: false, // 控制"没有更多了"的显示与隐藏
                error: false, // 控制访问接口异常情况下，可以再次重新访问接口
                areaCode:''
            }
        },
        mounted() {
            // this.changeList();   //初始化个人企业
            this.getCity();     //初始化市州
        },
        methods: {
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },
            /**
             * 企业与个人切换
             */
            changeList() {
                if (this.radio === '1') {
                    Dialog.alert({
                        message:'企业目前暂无数据！敬请谅解！'
                    }).then(()=>{
                        // this.enterprise = true
                        this.personal = false
                    })
                } else {
                    // this.personal = true
                    this.enterprise = false
                }
                this.city=''
                this.county=''
                this.$refs.childFunction.interactionVerificationCode()
            },

          submit() {
            if (!this.city) {
              Toast('请选择市州')
            } else if (!this.county) {
              Toast('请选择区县')
            } else {
              this.show=true
            }
          },

          async success(val) {
            try {
              this.ps = 100
              this.list = []
              const data = {
                ps: this.ps,
                pi: 1,
                areaCode:this.countyCode,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              if(this.radio ==='1'){
                Dialog.alert({
                  message:'企业目前暂无数据！敬请谅解！'
                }).then(()=>{
                })
              }else {
                Toast.loading({
                  duration: 0,       // 持续展示 toast
                  forbidClick: true, // 禁用背景点击
                  loadingType: 'spinner',
                  message: '查询中...'
                })
                const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.personalLocker}`, data)
                this.show = false
                Toast.clear()
                if (res.data.succ && res.data.data.list.length > 0) {
                  this.personal = true
                  this.list = res.data.data.list
                  if (this.ps >= res.data.data.totalRow) {
                    this.loading = false
                    this.finished = true
                  } else {
                    this.loading = true
                    this.finished = false
                  }
                } else {
                  this.finished = true
                  this.loading = false
                  Toast.fail('未查询到结果')
                }
              }
            } catch (error) {
              this.finished = true
              this.loading = false
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query(v) {
                if (!this.city) {
                    Toast('请选择市州')
                } else if (!this.county) {
                    Toast('请选择区县')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                }else{
                    this.queryData(v)
                }
            },

            //获取个人查询数据
            async queryData(v) {
                try {
                    this.ps = v
                    this.list = []
                    const data = {
                        ps: this.ps,
                        pi: 1,
                        areaCode:this.countyCode,
                        genGuid: this.receiveVerificationCode.verificationCodeGuid,
                        validCode: this.receiveVerificationCode.verificationCode
                    }
                    if(this.radio ==='1'){
                        Dialog.alert({
                            message:'企业目前暂无数据！敬请谅解！'
                        }).then(()=>{
                        })
                    }else {
                        Toast.loading({
                            duration: 0,       // 持续展示 toast
                            forbidClick: true, // 禁用背景点击
                            loadingType: 'spinner',
                            message: '查询中...'
                        })
                        const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.personalLocker}`, data)
                        Toast.clear()
                        //刷新图形验证码
                        this.$refs.childFunction.interactionVerificationCode()
                        if (res.data.succ && res.data.data.list.length > 0) {
                            this.personal = true
                            this.list = res.data.data.list
                            if (this.ps >= res.data.data.totalRow) {
                                this.loading = false
                                this.finished = true
                            } else {
                                this.loading = true
                                this.finished = false
                            }
                        } else {
                            this.finished = true
                            this.loading = false
                            Toast.fail('未查询到结果')
                        }
                    }
                } catch (error) {
                    this.finished = true
                    this.loading = false
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                }
            },
            back() {
                this.$router.go(-1);
            },
            //初始化加载城市
            getCity() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.region}/${global.cityCode}`).then(res=>{
                    let arr = [];
                    if(res.data.succ = true){
                        arr = res.data.data
                        this.cityList = arr;
                    }
                }).catch(error=>{

                })
            },
            //选择市州
            onConfirmCity(value) {
                this.city = value.regionname;
                this.cityCode = value.regioncode
                this.getCounty(this.cityCode)
                this.showPickerCity = false
                this.county = ''

            },
            //选择区县
            onConfirmCounty(value) {
                this.county = value.regionname
                this.countyCode = value.regioncode
                this.showPickerCounty = false
            },
            //获取区县列表
            getCounty() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.region}/${this.cityCode}`).then(response => {
                    let arr =[];
                    if(response.data.succ = true){
                        arr= response.data.data;
                        this.countyList = arr;
                    }

                })
            },
            // 加载更多
            async loadMore() {
                this.ps += 5
                this.queryData(this.ps)
            }
        }

    }
</script>

<style scoped>
    .van-line {
        border-top: 1px solid #F3F3F3;
    }

    .van-radio {
        display: flex;
    }

    .van-radio p {
        margin: 0.4rem 0 0.2rem 0.4rem;
    }

    .van-name {
        margin: 0.2rem 0.1rem 0 0.9rem;
    }

    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }
</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
